import React from "react";
import { Dispatch } from "redux";
import { SingleProductComponentV2 } from "./index";
import styled from "styled-components";
import { writeBackup } from "../Utils/helper";
import { getPartnerConfiguration } from "../Utils/windowHelper";

type Props = {
  packageState: any;
  singleProduct: any;
  language: string;
  setPackageState: Function;
  dispatch: Dispatch;
  updatePackagesAction: Function;
  createNewResponseObjectProductGui: Function;
  enabledTriggerValue: string;
  handleProductUpdate?: Function;
};

const ProductCard: React.FC<Props> = ({
  packageState,
  singleProduct,
  language,
  setPackageState,
  dispatch,
  updatePackagesAction,
  createNewResponseObjectProductGui,
  enabledTriggerValue,
  handleProductUpdate,
}) => {
  const productEnabled = singleProduct?.facts?.enabled === "1";

  /**
   * Handle product click (select/deselect)
   */
  const handleProductClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();

    // Use the optimistic update handler if provided
    if (handleProductUpdate) {
      handleProductUpdate(singleProduct, enabledTriggerValue);
      return;
    }

    // Legacy handling if handleProductUpdate not provided
    dispatch(
      updatePackagesAction(
        createNewResponseObjectProductGui(
          {
            packages: [packageState],
            combine_packages: true,
          },
          singleProduct?.product_id,
          "enabled",
          enabledTriggerValue
        )
      )
    );

    writeBackup("readStore", [packageState]);

    setPackageState({
      ...packageState,
      facts: {
        ...packageState?.facts,
        enabled: enabledTriggerValue,
      },
    });
  };

  const configuration = getPartnerConfiguration(packageState?.facts?.referer);
  const showDatesOnTimeLine = configuration?.SHOW_DATES_ON_TIMELINE;

  return (
    <div style={{ position: "relative" }}>
      {showDatesOnTimeLine && productEnabled && (
        <Vertical>
          <div className="top-height"></div>
        </Vertical>
      )}

      <SingleProductComponentV2
        key={singleProduct.product_id}
        singleProduct={singleProduct}
        language={language}
        referer={packageState?.facts?.referer}
        link={`packages/${packageState?.package_id && packageState?.package_id}/product/${
          singleProduct?.product_id && singleProduct?.product_id
        }`}
        onClick={handleProductClick}
      />

      {showDatesOnTimeLine && productEnabled && (
        <Vertical>
          <div className="bottom-height"></div>
        </Vertical>
      )}
    </div>
  );
};

const Vertical = styled.div`
  width: 100%;
  padding: 0 74.5px;
  margin: 0 auto;

  .top-height {
    height: 0.5rem;
  }
  .bottom-height {
    height: 1.5rem;
  }

  div {
    background: var(--vertical-line);
    z-index: -11;
    width: 2px;
  }

  @media screen and (min-width: 800px) {
    margin: 0 auto;
    width: 100%;
    padding: 0 81px;

    div {
      background: var(--vertical-line);
      width: 2px;
    }
  }
`;

export default ProductCard;
